<template>
  <div class="container">
    <h1>{{$t('global.Notification')}}</h1>
    <!-- <h3>Today</h3> -->
    <notifications></notifications>
  </div>
</template>

<script>
export default {
  components: {
    Notifications: () =>
      import(
        /* webpackChunkName: "notifications" */ "@/components/common/Notifications.vue"
      ),
  },
};
</script>
